<!-- 不动产统计首页 -->
<template>
    <div class='estate_contaniner'>
        <!--左边-->
        <div class="box_f1 box box_v" style="margin-right:10px">
            <left1 class="box box_f2" :communityId="communityIds" style="margin-bottom:10px"></left1>
            <left2 class="box box_f1" :communityId="communityIds" style="margin-top:10px"></left2>
        </div>
        <!--中间-->
        <div class="box_f2 box box_v" style="margin:0 10px">
            <div class="box box_f2 box_v"  style="margin-bottom:10px">
                <middle1 class="box" :communityId="communityIds" style="margin-bottom:5px"></middle1>
                <middle2 class="box_f1" :communityId="communityIds"></middle2>
            </div>
           <middle3 class="box box_f1" :communityId="communityIds" style="margin-top:10px"></middle3>
        </div>
        <!--右边-->
        <div class="box_f1 box box_v" style="margin-left:10px">
            <right1 class="box box_f2" :communityId="communityIds" style="margin-bottom:10px"></right1>
            <right2 class="box box_f1" :communityId="communityIds" style="margin-top:10px"></right2>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import left1 from "./left1.vue"
import left2 from "./left2.vue"
import middle1 from "./middle1.vue"
import middle2 from "./middle2.vue"
import middle3 from "./middle3.vue"
import right1 from "./right1.vue"
import right2 from "./right2.vue"
export default {
    props:['communityId'],
    //import引入的组件需要注入到对象中才能使用
    components: {left1,left2,middle1,middle2,middle3,right1,right2},
    data() {
    //这里存放数据
        return {
            communityIds:1,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        communityId:{
            handler(newVal){
                if(this.communityIds != newVal){
                    this.communityIds = newVal;
                }
            },
            deep:true
        }
    },
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.estate_contaniner{
    width:100%;
    height:100%;
    display: flex;
}
</style>